import React from 'react';

const FbIcon = ({ className }) => (
  <svg
    viewBox="0 0 257.7 257.7"
    width="257.7"
    height="257.7"
    className={className}
  >
    <path d="M213.9 0H43.8C19.6 0 0 19.6 0 43.8v170.1c0 24.2 19.6 43.8 43.8 43.8h93.8v-99.8H104V119h33.6V90.3c0-33.3 20.3-51.4 50-51.4 14.2 0 26.5 1.1 30 1.5v34.8H197c-16.1 0-19.3 7.7-19.3 18.9V119h38.5l-5 38.9h-33.5v99.8h36.1c24.2 0 43.8-19.6 43.8-43.8V43.8C257.7 19.6 238.1 0 213.9 0z" />
  </svg>
);

export default FbIcon;



// WEBPACK FOOTER //
// ./src/components/modules/Icons/facebook.js